import React, { useEffect, useState } from "react";
import { Field, Form as FormikForm, Formik } from "formik";
import * as select from "../data/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Icon, Modal, Table } from "semantic-ui-react";
import { FormikDateComponent, FormikInputComponent, FormikIntegerComponent } from "../../../utilities/formUtils";
import { setTableHeight } from "../../../utilities/heightSet";
import { fetchMaruti, repost, setNotifyDone, syncUtd } from "../data/actions";
import { setAlertModalState } from "../../common/data/actions";
import { toast } from "react-toastify";
import {
    missingUtd,
    missingUtdSchema,
    searchColumns
} from "../data/model";
import SyncOptions from "./syncOption";
import { TableListDiv } from "./tableListDiv";

// Placeholder for the value field, based on the selected sync option.
const SYNC_OPTION_PLACEHOLDER = {
    trans_id: "Trans Id",
    trans_ref_num: "Trans Ref No.",
    trans_date: "Trans Date",
    sync_date: "Sync Date",
};

let count = 0;

const MarutiList = (props) => {
    const dispatch = useDispatch();

    const allData = useSelector((state) => select.getFilteredMarutiList(state));
    const successData = useSelector((state) => select.getFilteredMarutiSuccessList(state));
    const inProcessData = useSelector((state) => select.getFilteredMarutiInProcessList(state));
    const errorData = useSelector((state) => select.getFilteredMarutiErrorList(state));
    const exceptionData = useSelector((state) => select.getFilteredMarutiExceptionList(state));
    const parkedData = useSelector((state) => select.getFilteredMarutiParkedList(state));
    const marutiFetched = useSelector((state) => select.getIsMarutiFetched(state, props));
    const notificationPopup = useSelector((state) => select.getNotificationPopup(state, props));

    const [isModalOpen, setModalOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [field, setField] = useState("");
    const [activeTab, setActiveTab] = useState("all");
    const [modalUtd, setModalUtd] = useState(false);
    const [heights, setHeight] = useState("");

    // Default search on landing: Sync Date = today
    const _today = new Date();
    const todayStr =
        _today.getFullYear() +
        "-" +
        String(_today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(_today.getDate()).padStart(2, "0");
    const data = { option: "sync_date", dtValue: todayStr };

    useEffect(() => {
        let notify = notificationPopup.type;
        if (notify) {
            let status =
                notify.status && notify.status !== undefined && notify.status !== null
                    ? notify.status
                    : "",
                msg =
                    notify.msg && notify.msg !== undefined && notify.msg !== null
                        ? notify.msg
                        : notify.msg,
                options = {};
            if (status !== "") {
                if (count === 0) {
                    if (status === "success") {
                        options = {
                            className: "toast-position",
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                        };
                        toast["success"](msg, options);
                    } else {
                        options = {
                            className: "toast-position",
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                        };
                        toast["error"](msg, options);
                    }
                    setTimeout(function () {
                        dispatch(setNotifyDone());
                        count = 0;
                    }, 500);
                    count++;
                }
            }
        }
    }, [notificationPopup]);

    useEffect(() => {
        if (!marutiFetched) dispatch(fetchMaruti(data));
        setActiveTab("all");
    }, [marutiFetched]);

    const fetchList = (values) => {
        if (!values.option) {
            dispatch(setAlertModalState({ isOpen: true, type: "error", size: "mini", title: "Warning", msg: "Please select a Sync Option." }));
            return;
        }
        const searchValue =
            values.option === "trans_ref_num" || values.option === "trans_id"
                ? values.txtValue
                : values.dtValue;
        if (!searchValue) {
            dispatch(setAlertModalState({ isOpen: true, type: "error", size: "mini", title: "Warning", msg: "Please select a value to search." }));
            return;
        }
        dispatch(fetchMaruti(values));
        setActiveTab("all");
    };

    const callHeightFunc = () => {
        setTableHeight(setHeight);
    };

    // Recompute the table height on mount and whenever the window is resized,
    // so the table body grows/shrinks to fill the available space.
    useEffect(() => {
        callHeightFunc();
        const onResize = () => callHeightFunc();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showDetails = (syncObj) => {
        setErrorMsg(syncObj);
        setTimeout(() => {
            setModalOpen(true);
        }, 200);
    };

    const reposting = (redisId) => {
        dispatch(repost(redisId));
    };

    const postParked = (syncObj) => {
        dispatch(syncUtd({ utd: syncObj.UTD }));
    };

    const syncAction = ({ object: syncObj }) => {
        return (
            <>
                {syncObj.type === "error" || syncObj.type === "exception" ? (
                    <Table.Cell>
                        <span
                            style={{
                                textTransform: "capitalize",
                                color: "red",
                                cursor: "pointer",
                            }}
                            onClick={() => showDetails(syncObj)}
                        >
                            {syncObj.type}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {syncObj["postStatus"] === undefined ? (
                            <span
                                style={{ color: "blue", cursor: "pointer" }}
                                onClick={() => reposting(syncObj.redisId)}
                            >
                                Repost
                            </span>
                        ) : (
                            <span style={{ color: "green" }}>Reposted</span>
                        )}
                    </Table.Cell>
                ) : syncObj.type === "parked" ? (
                    <Table.Cell>
                        {syncObj.posted ? (
                            <span style={{ color: "green" }}>Posted</span>
                        ) : (
                            <span
                                style={{ color: "blue", cursor: "pointer" }}
                                onClick={() => postParked(syncObj)}
                            >
                                Post
                            </span>
                        )}
                    </Table.Cell>
                ) : (
                    <Table.Cell
                        style={{
                            color: "green",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            marginRight: "20px",
                        }}
                        onClick={() => showDetails(syncObj)}
                    >
                        {syncObj.type}
                    </Table.Cell>
                )}
            </>
        );
    };

    const changeComponent = (value) => {
        if (value.option === "trans_ref_num" || value.option === "trans_id") {
            setField("inputField");
        } else {
            setField("");
        }
    };

    const syncUtdNum = (value) => {
        if (value.utd) {
            dispatch(syncUtd(value))
            setModalUtd(false)
        }
    }

    // Single source of truth for the status tabs. Only one is active at a time
    // (tracked by `activeTab`), so the table below just renders the active list.
    const tabs = [
        { key: "all", label: "All", data: allData },
        { key: "success", label: "Success", data: successData },
        { key: "inprocess", label: "In-Process", data: inProcessData },
        { key: "error", label: "Error", data: errorData },
        { key: "exception", label: "Exception", data: exceptionData },
        { key: "parked", label: "Park & Post", data: parkedData },
    ];
    const activeData = (tabs.find((t) => t.key === activeTab) || tabs[0]).data;

    return (
        <>
            <div id="pageHeader">
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 4px 12px",
                    gap: "12px",
                    flexWrap: "wrap",
                }}>
                    <div>
                        <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                            DMS Txn Sync
                        </div>
                        <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                            Maruti DMS transactions sync status.
                        </div>
                    </div>
                    <Formik
                        id="commissionSearch"
                        initialValues={{ option: "sync_date", dtValue: todayStr, txtValue: "" }}
                        onSubmit={(values) => {
                            fetchList(values);
                        }}
                        render={({
                            handleSubmit,
                            errors,
                            onChange,
                            values,
                            handleChange,
                        }) => (
                            <Form
                                as={FormikForm}
                                size="small"
                                onSubmit={handleSubmit}
                                style={{ marginBottom: 0 }}
                            >
                                <Form.Group style={{ marginBottom: 0, alignItems: "flex-end" }}>
                                    <SyncOptions
                                        isLabel={true}
                                        onChange={changeComponent(values)}
                                        name="option"
                                        placeholder="Sync Option "
                                        isTxn={false}
                                        isSelection={true}
                                    />
                                    {field === "" ? (
                                        <Field
                                            name="dtValue"
                                            isAutoComplete={true}
                                            component={FormikDateComponent}
                                            isLabel="false"
                                            isTxn="true"
                                            placeholder={SYNC_OPTION_PLACEHOLDER[values.option] || "Sync Date"}
                                        />
                                    ) : (
                                        <Field
                                            name="txtValue"
                                            component={FormikInputComponent}
                                            isLabel="false"
                                            isTxn="true"
                                            placeholder={SYNC_OPTION_PLACEHOLDER[values.option] || "Trans Id"}
                                        />
                                    )}
                                    <Button type="submit" size="small" color="blue" icon labelPosition="left">
                                        <Icon name="search" />
                                        Search
                                    </Button>
                                    <Button
                                        type="button"
                                        size="small"
                                        color="teal"
                                        icon
                                        labelPosition="left"
                                        onClick={() => {
                                            setModalUtd(true);
                                        }}
                                    >
                                        <Icon name="paper plane" />
                                        Post Missing UTD
                                    </Button>
                                </Form.Group>
                            </Form>
                        )}
                    />
                </div>
                <div className="syncTabsBar">
                    {tabs.map((tab) => (
                        <div
                            key={tab.key}
                            className={activeTab === tab.key ? "syncTab syncTabActive" : "syncTab"}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            {tab.label}
                            <span className="syncTabCount">{tab.data.length}</span>
                        </div>
                    ))}
                </div>
            </div>

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <div style={{ paddingTop: "10px" }}>
                    <TableListDiv
                        columns={searchColumns}
                        data={activeData}
                        Actions={syncAction}
                        setHeight={heights}
                        getIndex={9}
                        filterBoxNone={""}
                        rightBox={""}
                        centerBox={""}
                        callHeightFunc={callHeightFunc}
                        paddingShort={2}
                        getWidth={"100%"}
                        actionClass={"actionTdDR"}
                    />
                </div>
            )}
            <Modal
                open={modalUtd}
                size="tiny"
                onClose={() => setModalUtd(false)}
            >
                <div
                    style={{
                        background: "#2185d0",
                        color: "#ffffff",
                        padding: "14px 22px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderTopLeftRadius: "4px",
                        borderTopRightRadius: "4px",
                    }}
                >
                    <span style={{ fontSize: "17px", fontWeight: 600 }}>
                        Post Missing UTD
                    </span>
                    <Icon
                        name="close"
                        link
                        style={{ color: "#ffffff", margin: 0 }}
                        onClick={() => setModalUtd(false)}
                    />
                </div>
                <Modal.Content>
                    <Formik
                        id="itemForm"
                        initialValues={missingUtd()}
                        validationSchema={missingUtdSchema}
                        onSubmit={(values, { resetForm }) => syncUtdNum(values, resetForm)}
                        render={({ handleSubmit }) => (
                            <Form as={FormikForm} size="small" onSubmit={handleSubmit}>
                                <Field
                                    name="utd"
                                    label="UTD Number"
                                    component={FormikIntegerComponent}
                                    isMandatory={true}
                                    placeholder="Enter UTD number"
                                />
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        marginTop: "22px",
                                    }}
                                >
                                    <Button
                                        type="submit"
                                        color="blue"
                                        icon
                                        labelPosition="left"
                                    >
                                        <Icon name="paper plane" />
                                        Post
                                    </Button>
                                </div>
                            </Form>
                        )}
                    />
                </Modal.Content>
            </Modal>
            <Modal open={isModalOpen} size="small">
                <Modal.Header>
                    {" "}
                    {errorMsg.type === ("exception" || "Exception")
                        ? "Exception Msg"
                        : errorMsg.type === ("error" || "Error")
                            ? "Error Msg"
                            : "Success Msg"}
                </Modal.Header>
                <Modal.Content>
                    <h4>redisId :&nbsp; {errorMsg ? errorMsg.redisId : ""}</h4>
                    <h4>{errorMsg ? errorMsg.msg : ""}</h4>
                </Modal.Content>
                <Modal.Actions>
                    <Button type="button" positive onClick={() => setModalOpen(false)}>
                        Ok
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default MarutiList;